import { SdkBundleRow, SdkScriptRow } from "src/settings/sdks/types";

const matchesQuery = (fields: string[], query: string): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery.length === 0) {
    return true;
  }
  return fields.some((field) => field.toLowerCase().includes(normalizedQuery));
};

export const filterSdkBundleRows = (
  rows: SdkBundleRow[],
  query: string,
): SdkBundleRow[] =>
  rows.filter((row) =>
    matchesQuery(
      [row.id, row.name, ...row.scripts.map((script) => script.name)],
      query,
    ),
  );

export const filterSdkScriptRows = (
  rows: SdkScriptRow[],
  query: string,
): SdkScriptRow[] =>
  rows.filter((row) =>
    matchesQuery([row.id, row.name, row.providerLabel], query),
  );
